import React, { FC, useEffect } from 'react';
import { Box, Checkbox, FormGroup, TextField, Typography } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';

interface Props {
  question: any;
  step: number;
  onChange: (
    qid: string,
    val: string,
    i: number,
    p: boolean,
    d: boolean,
    additionalData: Record<string, string | boolean>
  ) => Promise<void>;
  value?: string;
  selectedLanguage: string;
}

const CustomQuestionText: FC<Props> = ({ question, step, onChange, value, selectedLanguage }) => {
  const currentLanguage = selectedLanguage ?? 'de-DE';
  const [privacyNoticeChecked, setPrivacyNoticeChecked] = React.useState(false);
  const translatePlaceholder = () => {
    return question.questionI18n?.placeholder?.[currentLanguage] ?? question.placeholder ?? '';
  };

  useEffect(() => {
    console.log(privacyNoticeChecked);
  }, [privacyNoticeChecked]);
  const translatePrivacyNoticeText = () => {
    return (
      question.questionI18n?.PrivacyNoticeText?.[currentLanguage] ??
      question.PrivacyNoticeText ??
      ''
    );
  };
  return (
    <>
      <Box className="survey-custom-question survey-custom-question--text">
        <FormGroup className="survey-answer-form-group">
          <TextField
            className="survey-text-answer-input"
            id="custom-outlined-multiline-static"
            multiline
            placeholder={translatePlaceholder()}
            rows={4}
            value={value}
            variant="outlined"
            sx={{
              width: '96%',
            }}
            onChange={async (e: any) => {
              await onChange(
                question.questionId || '',
                e.target.value,
                step,
                false,
                question.ShouldShowPrivacyNotice &&
                  e.target.value.length > 0 &&
                  !privacyNoticeChecked,
                { has_accepted_privacy_notice: privacyNoticeChecked }
              );
            }}
          />
        </FormGroup>
      </Box>
      {question.ShouldShowPrivacyNotice && (
        <Box className="survey-privacy-notice">
          <Typography className="survey-privacy-notice-text">
            <Checkbox
              className="survey-privacy-notice-checkbox"
              checked={privacyNoticeChecked}
              onChange={() => {
                setPrivacyNoticeChecked((prev) => {
                  onChange(
                    question.questionId || '',
                    value ?? '',
                    step,
                    false,
                    question.ShouldShowPrivacyNotice && prev,

                    { has_accepted_privacy_notice: !prev }
                  );
                  return !prev;
                });
              }}
            ></Checkbox>
            {translatePrivacyNoticeText()}{' '}
            <a
              href={question.PrivacyNoticeLink}
              target="_blank"
              rel="noreferrer"
            >
              <OpenInNew
                fontSize="small"
                color="primary"
              ></OpenInNew>
            </a>
          </Typography>
        </Box>
      )}
    </>
  );
};

export default CustomQuestionText;
